/*
 * Abre e fecha o texto de SEO.
 *
 * O `max-height` e escrito em px pelo JS na hora de animar porque a transicao
 * de CSS nao interpola de um valor fixo para `none`. O fluxo e sempre:
 * px atual -> px destino, e no fim da abertura o inline style e limpo para o
 * texto voltar a se ajustar sozinho se a janela mudar de largura.
 */
(() => {
  const SELETOR = "[data-seo-collapse]";

  class SeoCollapse {
    constructor(root) {
      this.root = root;
      this.content = root.querySelector("[data-seo-collapse-content]");
      this.toggle = root.querySelector("[data-seo-collapse-toggle]");
      if (!this.content || !this.toggle) return;

      this.aberto = false;
      this.avaliar();
      this.toggle.addEventListener("click", () => this.alternar());

      // A altura do texto muda com a largura da tela e quando as fontes
      // terminam de carregar; sem reavaliar, um texto que cabia inteiro passa a
      // ficar cortado sem botao para abrir (ou o contrario).
      if ("ResizeObserver" in window) {
        this.observer = new ResizeObserver(() => this.avaliar());
        this.observer.observe(this.content);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.avaliar());
      }
    }

    get alturaFechada() {
      const valor = parseInt(getComputedStyle(this.root).getPropertyValue("--bs-seo-collapsed"), 10);
      return Number.isFinite(valor) ? valor : 220;
    }

    // Texto curto nao vira colapsavel: aparece inteiro e sem botao.
    avaliar() {
      if (this.aberto || this.animando) return;
      const cabe = this.content.scrollHeight <= this.alturaFechada + 1;
      this.root.classList.toggle("is-ready", !cabe);
      this.root.classList.toggle("is-collapsed", !cabe);
      this.toggle.setAttribute("aria-expanded", "false");
      this.sincronizarRotulo();
    }

    sincronizarRotulo() {
      const { labelMore, labelLess } = this.toggle.dataset;
      this.toggle.textContent = this.aberto ? labelLess : labelMore;
    }

    alternar() {
      this.aberto = !this.aberto;
      this.animando = true;
      this.toggle.setAttribute("aria-expanded", String(this.aberto));
      this.sincronizarRotulo();

      const alturaTotal = this.content.scrollHeight;
      // ponto de partida explicito para a transicao ter de onde sair
      this.content.style.maxHeight = `${this.aberto ? this.alturaFechada : alturaTotal}px`;
      // força o reflow antes de trocar o destino, senao o browser junta as duas
      // escritas num quadro so e a animacao nao acontece
      void this.content.offsetHeight;

      this.root.classList.toggle("is-collapsed", !this.aberto);
      this.content.style.maxHeight = `${this.aberto ? alturaTotal : this.alturaFechada}px`;

      const aoTerminar = () => {
        this.content.removeEventListener("transitionend", aoTerminar);
        this.animando = false;
        // aberto: solta a altura para o texto refluir sozinho.
        // fechado: quem manda e o CSS, entao o inline sai do caminho.
        this.content.style.maxHeight = "";
      };
      this.content.addEventListener("transitionend", aoTerminar);
    }
  }

  const iniciar = () => document.querySelectorAll(SELETOR).forEach((el) => {
    if (!el.seoCollapse) el.seoCollapse = new SeoCollapse(el);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
  // o editor de temas remonta a section a cada alteracao
  document.addEventListener("shopify:section:load", iniciar);
})();
